import { window } from "global";
import { useLocation } from "react-router-dom";
import { RiotAssetsProvider } from "@outplayed/riot-assets";
import { ResponsiveProvider, MediaQuery } from "@outplayed/responsive";

import ApolloWrapper from "components/ApolloWrapper";
import MobileMenu from "components/MobileMenu/MobileMenu";
import Masthead from "components/Masthead/Masthead";
import MainContent from "components/MainContent/MainContent";
// import Footer from "components/Footer/Footer";
import OpenSearch from "components/OpenSearch";
import { FreestarContainer } from "components/common/Ads/FreestarContainer";
import { Test } from "./Test";
import Footer from "@ugitgud/legos/ui/footer/Footer";
import { ReactComponent as Logo } from "svg/pbs-logo.svg";
import { ReactComponent as LogoFull } from "svg/logo-full.svg";

import { DEFAULT_BREAKPOINT, BREAKPOINTS } from "constants.js";

const App = (props) => {
  const { client } = props;
  const location = useLocation();

  if (location.pathname.includes("/opensearch")) {
    return (
      <RiotAssetsProvider staging={process.env.RIOT_PATCH_ASSETS === "staging"} ssr>
        <OpenSearch />
      </RiotAssetsProvider>
    );
  }

  return (
    <>
      <ApolloWrapper client={client}>
        <RiotAssetsProvider staging={process.env.RIOT_PATCH_ASSETS === "staging"} ssr>
          <ResponsiveProvider breakpoints={BREAKPOINTS} defaultBreakpoint={DEFAULT_BREAKPOINT}>
            <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" isClient renderNullOnFail>
              <MobileMenu />
            </MediaQuery>
            <FreestarContainer />
            <Masthead />
            <MainContent />
            <Footer
              logo={
                <div className="footer-logo">
                  <Logo className="logo" />
                  <LogoFull className="logo-full" />
                </div>
              }
              termsLinks={
                <li className="footer-link-item">
                  <button id="pmLink">Privacy Manager</button>
                </li>
              }
            />
            <Test />
          </ResponsiveProvider>
        </RiotAssetsProvider>
      </ApolloWrapper>
    </>
  );
};

export default App;
